import { render } from "./invite-a-friend-menu-item.vue?vue&type=template&id=ed96b4f6&ts=true"
import script from "./invite-a-friend-menu-item.vue?vue&type=script&lang=ts"
export * from "./invite-a-friend-menu-item.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__